import { Add } from "@mui/icons-material"
import { Box, Button, LinearProgress, Typography } from "@mui/material"
import React from "react"

import SortedDataGridPro6 from "../../../../../../../../design/sorted-datagrid-pro-6"
import useGatAdminConfigData from "../../../../../../controllers/use-gat-admin-config-data"
import useShiftPurposeColumns from "../../controllers/use-shift-purpose-columns"

interface ShiftPurposeTableProps {
	handleOpenEdit: (row: any) => void
	handleOpenAdd: () => void
}

function ShiftPurposeTable({ handleOpenEdit, handleOpenAdd }: ShiftPurposeTableProps) {
	const {
		shiftPurposesData,
		getShiftPurposesStatus,
		updateShiftPurposeStatusStatus,
	} = useGatAdminConfigData()
	const { columns } = useShiftPurposeColumns(handleOpenEdit)

	return (
		<Box
			sx={{
				border: "1px solid var(--divider, rgba(0, 0, 0, 0.12))",
				borderRadius: "8px",
				backgroundColor: "#fff",
				padding: "20px",
				marginTop: "16px",
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					justifyContent: "space-between",
					paddingTop: "20px",
					paddingBottom: "20px",
				}}
			>
				<Typography
					sx={{
						fontFamily: "Roboto",
						fontWeight: 400,
						fontSize: "16px",
						lineHeight: "24px",
						color: "#000000DE",
					}}
				>
					Shift Purposes
				</Typography>
				<Button
					disableElevation
					sx={{ height: 36 }}
					variant='outlined'
					color='primary'
					onClick={handleOpenAdd}
					startIcon={<Add />}
				>
					Shift Purpose
				</Button>
			</Box>
			<Box sx={{ padding: "12px 8px" }}>
				<SortedDataGridPro6
					columns={columns}
					rows={shiftPurposesData}
					defaultSortField='name'
					disableColumnSelector
					disableDensitySelector
					disableColumnMenu
					pagination
					initialState={{
						pagination: { paginationModel: { pageSize: 10 } },
						filter: {},
					}}
					pageSizeOptions={[10, 25, 50]}
					autoHeight
					getRowHeight={() => "auto"}
					loading={
						getShiftPurposesStatus === "pending" ||
						updateShiftPurposeStatusStatus === "pending"
					}
					slots={{
						loadingOverlay: () => <LinearProgress />,
					}}
					sx={{
						border: "none !important",
						".MuiDataGrid-cell": {
							"&:focus": { outline: "none" },
							"&.hover-column-cell": {
								position: "sticky",
								right: 0,
								zIndex: 1,
							},
							"& .hover-content": {
								transition: "opacity 0.3s ease-in-out",
								opacity: 0,
								backgroundColor: "transparent",
							},
						},
						".MuiDataGrid-cell:focus-within": { outline: "none" },
						"& .MuiDataGrid-columnHeader:focus-within": { outline: "none" },
						".MuiDataGrid-row:hover .hover-column-cell .hover-content": {
							opacity: 1,
							backgroundColor: "transparent",
						},
					}}
				/>
			</Box>
		</Box>
	)
}

export default ShiftPurposeTable
